import React, { useState } from "react";
import "./InputStyle.css";
import { Img } from "../Img";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string; // Optional label for the input
  isError?: boolean; // Optional error flag
  errorText?: string; // Optional error message
  textarea?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  isError = false,
  errorText,
  id, // Ensure 'id' can be passed as a prop
  textarea,
  ...rest
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const inputType = () => {
    if (rest.placeholder === "Password" && passwordVisible) {
      return "text";
    } else if (rest.placeholder !== "Password") {
      return "text";
    } else {
      return "password";
    }
  };

  return (
    <div className="self-stretch flex flex-row justify-start items-center  xs:h-[38px] 5xl:h-[54px] xs:text-xs 5xl:text-lg  gap-2 py-1.5 px-4 rounded-lg border border-blue_gray-50_04">
      {" "}
      {label && (
        <label
          htmlFor={id}
          className=" xs:!text-md 5xl:!text-xl border border-y-white-A700
           border-l-white-A700 pr-3
            border-lightGray text-blue_gray-500"
        >
          {label}
        </label>
      )}{" "}
      {/* Link label to input */}
      <input
        id={id} /* Assign the ID to the input */
        className={`w-full xs:!text-xs 5xl:!text-xl !text-gray-200 ${
          isError ? "input-error" : ""
        }`} /* Conditional error class */
        type={inputType()}
        {...rest}
      />
      {rest.placeholder === "Password" && (
        <Img
          src={passwordVisible ? "images/hideEye.svg" : "images/eye.svg"}
          alt="eye"
          className="hover:cursor-pointer"
          onClick={() => setPasswordVisible(!passwordVisible)}
        />
      )}
      {isError && errorText && <span className="error-text">{errorText}</span>}{" "}
      {/* Display error message if any */}
    </div>
  );
};

export default Input;
